var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-main"},[_c('div',[_vm._v(_vm._s(_vm.$t('总金额:'))+" "+_vm._s(_vm.invitationPrice)+" "+_vm._s(_vm.$t('元')))]),_c('div',{staticClass:"button",on:{"click":function($event){return _vm._click()}}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }